export default "__VITE_ASSET__CpJ7ghOh__"